<template>
  <div class="row py-5" id="stamps">
    <div class="col-12">
      <div class="container-xxl">
        <div class="">

          <div class="stamps ">
            <h2 class="title mb-5">Nossas<strong> conquistas</strong></h2>

            <div>
              <div class="swiper-container swiper mySwiper" ref="mySwiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="selos"><img src="@/assets/images/icons/a.svg" alt="selos"></div>
                  </div>
                  <div class="swiper-slide">
                    <div class="selos"><img src="@/assets/images/icons/abracam.svg" alt="selos"></div>
                  </div>
                  <div class="swiper-slide">
                    <div class="selos"><img src="@/assets/images/icons/top.svg" alt="selos"></div>
                  </div>
                  <div class="swiper-slide">
                    <div class="selos selo-gptw"><img src="@/assets/images/icons/gptw.png" alt="selos"></div>
                  </div>
                </div>

                <div
                  style="color: #00CFD9"
                  class="swiper-button-prev swiper-button-prev2"
                  ref="swiper-button-prev2"
                ></div>
                <div
                  style="color: #00CFD9"
                  class="swiper-button-next swiper-button-next2"
                  ref="swiper-button-next2"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from "swiper";
  import "swiper/swiper-bundle.css";
  import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
  SwiperCore.use([Navigation, Pagination, Autoplay]);

  export default {
    name: 'Stamps',

    data(){
      return {
      }
    },

    computed: {
    },

    methods: {
    },

    mounted(){
      setTimeout(() => {
        var swiper = new Swiper(this.$refs["mySwiper"], {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: true,

          navigation: {
            nextEl: this.$refs["swiper-button-next2"],
            prevEl: this.$refs["swiper-button-prev2"],
          },

          breakpoints: {
            522: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        });
      }, 150);
    }
  }
</script>

<style lang="scss" scoped>
  .stamps{
    width: 100%;
    text-align: center;
    padding: 0 0;
    @media screen and (max-width: 1100px) {
      padding: 0;
    }

    h2{
      font-size: 36px;
      color: #0A1D6F;
      font-weight: 400;

      strong{
        color: #00CFD9;
        font-weight: bold;
      }
    }

    .selos {
      width: 170px;
      margin: auto;
      &.selo-gptw {
        transform: scale(1.39);
      }
    }
  }
</style>
